import React, { useState, useEffect } from "react";
import $ from "jquery";
import "datatables.net-dt/js/dataTables.dataTables.js";
import { Icon } from "@iconify/react/dist/iconify.js";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
import { createMRTColumnHelper } from "material-react-table";
import {
  Box,
  IconButton,
  Tooltip,
  Modal,
  Typography,
  Button,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
} from "@mui/material";
import Chip from "@mui/material/Chip";
import { baseUrl } from "../../../../helper/urls";
import AdminCustomTable from "../../../../components/custom_table/AdminCustomTable.jsx";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { useSelector } from "react-redux";

const Approved = ({ url }) => {
  const { token } = useSelector((state) => state.auth);
  const [counselors, setCounselors] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [priceList, setPriceList] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const navigate = useNavigate();

  const formatDateToLocalYYYYMMDD = (date) => {
    if (!date) return "";
    const d = new Date(date); // safe if date is already a string
    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear();
    return `${year}-${month}-${day}`;
  };
  const fetchCounselors = async (
    startDateParam = null,
    endDateParam = null
  ) => {
    try {
      const params = new URLSearchParams();

      if (startDateParam) {
        params.append("startDate", formatDateToLocalYYYYMMDD(startDateParam));
      }
      if (endDateParam) {
        params.append("endDate", formatDateToLocalYYYYMMDD(endDateParam));
      }
      const queryString = params.toString();
      const apiUrl = queryString
        ? `${baseUrl}/api/${url}?${queryString}`
        : `${baseUrl}/api/${url}`;
      const response = await axios.get(apiUrl, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      setCounselors(response.data.data);
      setLoading(false);
    } catch (error) {
      setError(error);
      setLoading(false);
    }
  };

  const handleDateFilter = () => {
    setLoading(true);
    fetchCounselors(startDate, endDate); // These can be Date objects or strings
  };

  const handleClearFilter = () => {
    setStartDate(null);
    setEndDate(null);
    setLoading(true);
    fetchCounselors();
  };

  useEffect(() => {
    fetchCounselors();
    setLoading(false);
    const table = $("#dataTable").DataTable({
      pageLength: 5,
    });
    return () => {
      table.destroy(true);
    };
  }, []);

  const toggleApproval = async (id, currentStatus) => {
    if (!id) {
      Swal.fire("Error", "Invalid counselor ID.", "error");
      return;
    }
    const isApprove = currentStatus === 1;
    const action = isApprove ? "Approve" : "Reject";

    let result;

    if (isApprove) {
      result = await Swal.fire({
        title: '<h5 style="font-size: 14px; margin: 0;">Approve Counselor</h5>',
        html: `
  <div style="text-align: right; font-size: 13px;">
  <div style="display: flex; align-items: center; justify-content: space-between;  ">
  <label for="commission">Enter Commission (%)</label>
    <input type="number" id="commission" class="swal2-input" placeholder="Commission (%)" 
     style="margin-right: 0px;"
    />
  </div>

  <div style="display: flex; align-items: center; justify-content: space-between;">
  <label for="price">Please enter price per hour ($)</label>
    <input type="number" id="price" class="swal2-input" placeholder="Price per Hour" 
     style="margin-right: 0px;"
    />
  </div>
</div>

  `,
        focusConfirm: false,
        showCancelButton: true,
        confirmButtonText: "Submit",
        cancelButtonText: "Cancel",
        preConfirm: () => {
          const commission = document.getElementById("commission").value;
          const price = document.getElementById("price").value;

          if (!commission || !price) {
            Swal.showValidationMessage("Please fill out both fields.");
            return false;
          }

          return {
            commission_per: parseFloat(commission),
            price_per_hour: parseFloat(price),
          };
        },
      });
    } else {
      result = await Swal.fire({
        title: '<h5 style="font-size: 10px; margin: 0;">Reject Counselor</h5>',
        input: "textarea",
        inputLabel: "Plese enter reason for rejection",
        inputPlaceholder: "Type the reason here...",
        showCancelButton: true,
        confirmButtonText: "Submit",
        cancelButtonText: "Cancel",
        inputValidator: (value) => {
          if (!value.trim()) {
            return "Rejection reason is required.";
          }
        },
      });
    }

    if (!result.isConfirmed || result.dismiss) return;

    try {
      const payload = isApprove
        ? {
            status: 1,
            commission_per: result.value.commission_per,
            price_per_hour: result.value.price_per_hour,
            rejection_reason: null,
          }
        : {
            status: 0,
            commission_per: null,
            price_per_hour: null,
            rejection_reason: result.value,
          };

      await axios.put(`${baseUrl}/api/counselors/${id}/status`, payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      fetchCounselors();
      Swal.fire(
        "Success",
        `Counselor ${action.toLowerCase()}d successfully!`,
        "success"
      );
    } catch (error) {
      console.error(`Error ${action.toLowerCase()}ing counselor:`, error);
      const message =
        error.response?.data?.message || error.message || `${action} failed`;
      Swal.fire("Error", message, "error");
    }
  };

  const handleDelete = (id) => {
    Swal.fire({
      html: `<div style="font-size: 30px; font-weight: bold;">Are you sure?</div>`,
      text: "This action will permanently delete the counselor.",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .delete(`${baseUrl}/api/counselors/destory/${id}`, {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          })
          .then(() => {
            // Refresh the list
            fetchCounselors();
            Swal.fire("Deleted!", "Counselor has been deleted.", "success");
          })
          .catch((error) => {
            console.error("Error deleting counselor:", error);
            const message =
              error.response?.data?.message ||
              error.message ||
              "Failed to delete counselor.";
            Swal.fire("Error", message, "error");
          });
      }
    });
  };

  const handleToggleHideCounselor = (rowData) => {
    const isCurrentlyVisible = rowData.status === 1;
    const actionText = isCurrentlyVisible ? "hide" : "unhide";
    // const nextStatus = isCurrentlyVisible ? 3 : 1;

    Swal.fire({
      title: `Are you sure ?`,
      text: `This action will ${actionText} the counselor.`,
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: `Yes, ${actionText} it!`,
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .get(
            `${baseUrl}/api/counselors/hideUnHide?id=${rowData.id}&status=${rowData.status}`,
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
              },
            }
          )
          .then(() => {
            fetchCounselors();
            Swal.fire(
              `${actionText.charAt(0).toUpperCase() + actionText.slice(1)}d!`,
              `Counselor has been ${actionText}d.`,
              "success"
            );
          })
          .catch((error) => {
            console.error(`Error trying to ${actionText} counselor:`, error);
            const message =
              error.response?.data?.message ||
              error.message ||
              `Failed to ${actionText} counselor.`;
            Swal.fire("Error", message, "error");
          });
      }
    });
  };

  const fetchPriceList = async (id) => {
    try {
      const response = await axios.get(
        `${baseUrl}/api/counselors/pricePerHourList/${id}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setPriceList(response.data.data || []);
      console.log(response.data.data, "response dataaaaaaaaaaaaaa");
      setShowModal(true); // open modal after data is fetched
    } catch (error) {
      console.error("Failed to load price list", error);
    }
  };

  const remenderMail = async (id) => {
    if (!id) {
      Swal.fire("Error", "Invalid counselor ID.", "error");
      return;
    }

    try {
      const response = await axios.get(
        `${baseUrl}/api/counselors/reminderSend/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          // No `data` or body is allowed in GET requests
        }
      );

      console.log("Reminder email sent successfully:", response.data);
      Swal.fire("Success", "Reminder email sent successfully!", "success");
    } catch (error) {
      console.error("Error sending reminder email:", error);
      const message =
        error.response?.data?.message ||
        error.message ||
        "Failed to send reminder email.";
      Swal.fire("Error", message, "error");
    }
  };
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
  };

  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const columnHelper = createMRTColumnHelper();

  const columns = [
    columnHelper.accessor("status", {
      header: "Status",
      size: 30,
      Cell: ({ row }) => {
        const status = row.original?.status;

        if (status == 0) {
          return <Chip label="Rejected" color="error" variant="outlined" />;
        } else if (status == 1) {
          return <Chip label="Approved" color="success" variant="outlined" />;
        } else if (status == 2) {
          return <Chip label="Pending" color="warning" variant="outlined" />;
        } else if (status == 3) {
          return <Chip label="Hidden" color="primary" variant="outlined" />;
        }
      },
    }),
    columnHelper.accessor("profileImage", {
      header: "Profile Image",
      size: 100,
      Cell: ({ row }) =>
        row.original.profileImage != null ? (
          <img
            src={`${baseUrl}${row.original.profileImage}`}
            alt=""
            style={{
              width: 50,
              height: 50,
              borderRadius: "50%",
            }}
          />
        ) : (
          <div style={{ width: 50, height: 50 }}></div>
        ),
    }),

    columnHelper.accessor("firstName", {
      header: "Name",
      size: 30,
      Cell: ({ row }) => {
        const handleClick = () => {
          const id = row.original?.id;
          setSelectedId(id);
          fetchPriceList(id);
        };

        return (
          <Tooltip title="View Services" arrow>
            <span
              onClick={handleClick}
              style={{
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                gap: "5px",
              }}
            >
              {row.original?.firstName} {row.original?.lastName}{" "}
              <Icon icon="material-symbols:open-in-new" />
            </span>
          </Tooltip>
        );
      },
    }),

    columnHelper.accessor("email", {
      header: "Email",
      size: 30,
      Cell: (cell) => cell.row.original?.email || "-",
    }),

    columnHelper.accessor("phone", {
      header: "Phone",
      size: 30,
      Cell: ({ row }) => {
        const phone = row.original?.phone;
        const countryCode = row.original?.country_code;
        return phone ? `${countryCode} ${phone}` : "-";
      },
    }),
    // columnHelper.accessor("price_per_hour", {
    //   header: "Price/Hour ($)",
    //   size: 100,
    //   Cell: (cell) => cell.row.original?.price_per_hour || "-",
    // }),
    // columnHelper.accessor("commission_per", {
    //   header: "Commission (%)",
    //   size: 100,
    //   Cell: (cell) => cell.row.original?.commission_per || "-",
    // }),

    columnHelper.accessor("profile", {
      header: "Profile",
      size: 30,
      Cell: ({ row }) => {
        const profile = row.original?.profile;
        const isYes = profile === 1;

        return (
          <Chip
            label={isYes ? "Yes" : "No"}
            sx={{
              backgroundColor: isYes ? "green" : "red",
              color: "white",
              fontWeight: "bold",
            }}
            size="small"
          />
        );
      },
    }),

    columnHelper.accessor("document", {
      header: "Document",
      size: 30,
      Cell: ({ row }) => {
        const docStatus = row.original?.document;
        const isYes = docStatus === 1;

        return (
          <Chip
            label={isYes ? "Yes" : "No"}
            sx={{
              backgroundColor: isYes ? "green" : "red",
              color: "white",
              fontWeight: "bold",
            }}
            size="small"
          />
        );
      },
    }),

    columnHelper.accessor("bank", {
      header: "Bank",
      size: 30,
      Cell: ({ row }) => {
        const bankStatus = row.original?.bank;
        const isYes = bankStatus === 1;

        return (
          <Chip
            label={isYes ? "Yes" : "No"}
            sx={{
              backgroundColor: isYes ? "green" : "red",
              color: "white",
              fontWeight: "bold",
            }}
            size="small"
          />
        );
      },
    }),

    // columnHelper.accessor("interestedIn", {
    //   header: "Service Type",
    //   size: 30,
    //   Cell: (cell) => cell.row.original?.interestedIn || "-",
    // }),
    columnHelper.accessor("approval_reject_date", {
      header: "Approval Date",
      size: 30,
      Cell: (cell) =>
        cell.row.original?.approval_reject_date
          ? cell.row.original?.approval_reject_date.split("T")[0]
          : "-",
    }),

    columnHelper.accessor("created_at", {
      header: "Signup Date",
      size: 30,
      Cell: (cell) =>
        cell.row.original?.created_at
          ? cell.row.original?.created_at.split("T")[0]
          : "-",
    }),

    columnHelper.accessor("contract_start_date", {
      header: "Contract Start Date",
      size: 30,
      Cell: (cell) =>
        cell.row.original?.contract_start_date
          ? cell.row.original?.contract_start_date.split("T")[0]
          : "-",
    }),
    columnHelper.accessor("contract_end_date", {
      header: "Contract End Date",
      size: 30,
      Cell: (cell) =>
        cell.row.original?.contract_end_date
          ? cell.row.original?.contract_end_date.split("T")[0]
          : "-",
    }),

    columnHelper.accessor("username", {
      header: "Counselor ID",
      size: 30,
      Cell: (cell) => cell.row.original?.username || "-",
    }),
  ];

  const [commission, setCommission] = useState("");
  const [price, setPrice] = useState("");

  const handleSubmit = () => {
    const payload = {
      commission_per: parseFloat(commission),
      price_per_hour: parseFloat(price),
    };

    console.log("Submitted:", payload);
    // You can replace this with an axios POST/PUT request
    handleClose(); // Optionally close the modal
  };

  columns.unshift(
    columnHelper.accessor("Actions", {
      header: "Actions",
      size: 30,
      Cell: ({ cell }) => {
        const rowId = cell.row.original.id;
        const rowData = cell.row.original;

        return (
          <Box>
            <Tooltip title="View Profile" arrow>
              <button
                onClick={() => navigate("/view-profile", { state: rowData })}
                className="w-32-px h-32-px me-8 bg-success-focus rounded-circle border-0 d-inline-flex align-items-center justify-content-center"
                style={{ cursor: "pointer" }}
              >
                <Icon
                  icon="mingcute:eye-line"
                  style={{ color: "#28a745", fontSize: "20px" }}
                />
              </button>
            </Tooltip>
            {rowData.profile == "1" &&
              rowData.document == "1" &&
              (rowData.status == "0" || rowData.status == "2") && (
                <Tooltip title="View Profile" arrow></Tooltip>
              )}
            {/* <Tooltip title="Edit Counselor" arrow>
              <Link
                to="/add-counselor"
                state={{ initialData: rowData, isEdit: true }}
                // state={{ initialData: counselor, isEdit: true }}
                className="w-32-px h-32-px me-8 bg-success-focus text-success-main rounded-circle d-inline-flex align-items-center justify-content-center"
              >
                <Icon icon="lucide:edit" />
              </Link>
            </Tooltip> */}

            {/* <Tooltip title="Delete Counselor" arrow>
              <button
                onClick={() => handleDelete(rowId)}
                className="w-32-px h-32-px me-8 bg-danger-focus text-danger-main rounded-circle border-0 d-inline-flex align-items-center justify-content-center"
                style={{ cursor: "pointer" }}
              >
                <Icon icon="mingcute:delete-2-line" />
              </button>
            </Tooltip> */}
            {(rowData.status === "0" || rowData.status === "2") &&
              rowData.profile === "1" &&
              rowData.document === "1" && (
                <Tooltip title="Approve Counselor" arrow>
                  <button
                    onClick={() => toggleApproval(rowId, 1)}
                    className="w-32-px h-32-px me-8 bg-info-focus text-info-main rounded-circle border-0 d-inline-flex align-items-center justify-content-center"
                    style={{ cursor: "pointer" }}
                  >
                    <Icon icon="material-symbols:check" />
                  </button>
                </Tooltip>
              )}
            {/* {(rowData.status == "0" || rowData.status == "2") && (
              <Tooltip title="Approve Counselor" arrow>
                <button
                  onClick={() => toggleApproval(rowId, 1)}
                  className="w-32-px h-32-px me-8 bg-info-focus text-info-main rounded-circle border-0 d-inline-flex align-items-center justify-content-center"
                  style={{ cursor: "pointer" }}
                >
                  <Icon icon="material-symbols:check" />
                </button>
              </Tooltip>
            )} */}
            {!(
              rowData.profile == "1" &&
              rowData.document == "1" &&
              rowData.bank == "1"
            ) && (
              <Tooltip title="Send Reminder" arrow>
                <button
                  // onClick={ remenderMail}
                  onClick={() => remenderMail(rowId)}
                  className="w-32-px h-32-px me-8 pl-2 bg-info-focus text-info-main rounded-circle border-0 d-inline-flex align-items-center justify-content-center"
                  style={{ cursor: "pointer" }}
                >
                  <Icon icon="material-symbols:mail" />
                </button>
              </Tooltip>
            )}

            {(rowData.status == "1" || rowData.status == "2") && (
              <Tooltip title="Reject Counselor" arrow>
                <button
                  onClick={() => toggleApproval(rowId, 0)}
                  className="w-32-px h-32-px me-8 bg-warning-focus text-warning-main rounded-circle border-0 d-inline-flex align-items-center justify-content-center"
                  style={{ cursor: "pointer" }}
                >
                  <Icon icon="ic:round-close" />
                </button>
              </Tooltip>
            )}
            {rowData.status == "1" && (
              <Tooltip title="Hide Counselor" arrow>
                <IconButton onClick={() => handleToggleHideCounselor(rowData)}>
                  <VisibilityOffIcon /> {/* Represents HIDE */}
                </IconButton>
              </Tooltip>
            )}

            {rowData.status == "3" && (
              <Tooltip title="Unhide Counselor" arrow>
                <IconButton onClick={() => handleToggleHideCounselor(rowData)}>
                  <VisibilityIcon /> {/* Represents UNHIDE */}
                </IconButton>
              </Tooltip>
            )}
          </Box>
        );
      },
    })
  );

  const modalStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 800,
    bgcolor: "background.paper",
    borderRadius: 2,
    boxShadow: 24,
    p: 2,
  };

  const styles = {
    container: {
      display: "flex",
      flexWrap: "wrap",
      gap: "12px",
      padding: "16px",
      background: "#fff",
      borderRadius: "8px",
      marginBottom: "20px",
      alignItems: "flex-end",
    },
    group: {
      display: "flex",
      flexDirection: "column",
      gap: "4px",
    },
    label: {
      fontSize: "14px",
      fontWeight: 500,
      color: "#333",
    },
    input: {
      padding: "6px 10px",
      fontSize: "14px",
      height: "36px",
      border: "1px solid #ccc",
      borderRadius: "6px",
      minWidth: "180px",
    },
    iconButton: {
      width: "36px",
      height: "36px",
      border: "none",
      borderRadius: "50%",
      cursor: "pointer",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontSize: "18px",
      transition: "0.2s ease-in-out",
    },
    primary: {
      backgroundColor: "#e3f2fd",
      color: "#1976d2",
    },
    primaryHover: {
      backgroundColor: "#bbdefb",
    },
    secondary: {
      backgroundColor: "#fce4ec",
      color: "#d32f2f",
    },
    secondaryHover: {
      backgroundColor: "#f8bbd0",
    },
  };

  return (
    <>
      {/* Date Filter Section */}
      <div style={styles.container}>
        <div style={styles.group}>
          <label style={styles.label}>Start Date</label>
          <input
            type="date"
            value={startDate}
            max={endDate || ""}
            onChange={(e) => setStartDate(e.target.value)}
            style={styles.input}
          />
        </div>

        <div style={styles.group}>
          <label style={styles.label}>End Date</label>
          <input
            type="date"
            value={endDate}
            min={startDate || ""}
            onChange={(e) => setEndDate(e.target.value)}
            style={styles.input}
          />
        </div>

        <button
          style={{
            ...styles.iconButton,
            ...styles.primary,
          }}
          onClick={handleDateFilter}
          disabled={loading}
          title="Apply Filter"
          onMouseOver={(e) => {
            e.currentTarget.style.backgroundColor =
              styles.primaryHover.backgroundColor;
          }}
          onMouseOut={(e) => {
            e.currentTarget.style.backgroundColor =
              styles.primary.backgroundColor;
          }}
        >
          <Icon icon="material-symbols:search" />
        </button>

        <button
          style={{
            ...styles.iconButton,
            ...styles.secondary,
          }}
          onClick={handleClearFilter}
          disabled={loading}
          title="Clear Filter"
          onMouseOver={(e) => {
            e.currentTarget.style.backgroundColor =
              styles.secondaryHover.backgroundColor;
          }}
          onMouseOut={(e) => {
            e.currentTarget.style.backgroundColor =
              styles.secondary.backgroundColor;
          }}
        >
          <Icon icon="material-symbols:cancel-outline-rounded" />
        </button>
      </div>

      <Modal
        open={showModal}
        onClose={() => setShowModal(false)}
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
      >
        <Box sx={{ ...modalStyle, position: "relative" }}>
          {/* Close Button */}
          <button
            style={{
              position: "absolute",
              top: "28px",
              right: "30px",
              ...styles.iconButton,
              ...styles.secondary,
            }}
            onClick={() => setShowModal(false)}
            title="Clear Filter"
            onMouseOver={(e) => {
              e.currentTarget.style.backgroundColor =
                styles.secondaryHover.backgroundColor;
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.backgroundColor =
                styles.secondary.backgroundColor;
            }}
          >
            <Icon icon="material-symbols:cancel-outline-rounded" />
          </button>

          {/* Modal Title */}
          <Typography
            id="modal-title"
            variant="h6"
            component="h6"
            mb={2}
            sx={{
              fontWeight: "bold",
              backgroundColor: "#f5f5f5", // 🟨 Background for heading
              padding: "12px 16px",
              borderRadius: "4px",
            }}
          >
            Service Type List
          </Typography>

          {/* Price Table Container */}
          <div
            style={{
              maxHeight: "300px",
              overflowY: "auto",
              backgroundColor: "#f5f5f5",
              padding: "12px",
              borderRadius: "4px",
            }}
          >
            {priceList.length > 0 ? (
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell sx={{ py: "8px", px: 0, fontWeight: "bold" }}>
                      Service Type
                    </TableCell>
                    <TableCell sx={{ py: "8px", px: 0, fontWeight: "bold" }}>
                      1 Slot
                    </TableCell>
                    <TableCell sx={{ py: "8px", px: 0, fontWeight: "bold" }}>
                      5 Slots
                    </TableCell>
                    <TableCell sx={{ py: "8px", px: 0, fontWeight: "bold" }}>
                      10 Slots
                    </TableCell>
                    <TableCell sx={{ py: "8px", px: 0, fontWeight: "bold" }}>
                      15 Slots
                    </TableCell>
                    <TableCell sx={{ py: "8px", px: 0, fontWeight: "bold" }}>
                      Commission
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {priceList.map((item, index) => (
                    <TableRow key={index}>
                      <TableCell sx={{ py: "8px", px: 0 }}>
                        {item.service_type}
                      </TableCell>
                      <TableCell sx={{ py: "8px", px: 0 }}>
                        ${item.rate_1_slot}
                      </TableCell>
                      <TableCell sx={{ py: "8px", px: 0 }}>
                        ${item.rate_5_slot}
                      </TableCell>
                      <TableCell sx={{ py: "8px", px: 0 }}>
                        ${item.rate_10_slot}
                      </TableCell>
                      <TableCell sx={{ py: "8px", px: 0 }}>
                        ${item.rate_15_slot}
                      </TableCell>
                      <TableCell sx={{ py: "8px", px: 0 }}>
                        {item.commission}%
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            ) : (
              <Typography sx={{ display: "flex", justifyContent: "center" }}>
                No Service Type List available.
              </Typography>
            )}
          </div>
        </Box>
      </Modal>

      <AdminCustomTable columns={columns} data={counselors} loading={loading} />
    </>
  );
};

export default Approved;
